import * as React from 'react';
import LogoutController from "./LogoutController";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Subbar} from "ah-tools";
import {Image} from "semantic-ui-react";
import avatar from '../images/avatar-m.gif';
import {push} from "react-router-redux";
import {ROUTE_PROFILE} from "../routes";
import {IconButton} from '../extensions';

class Header extends React.Component {
	render() {
		const {onPush} = this.props;
		return (
			<header className="ah-main" style={{zIndex: 2}}>
				<Subbar align={Subbar.ALIGN_END} style={{marginLeft: 150, width: '100%'}}>
					<Subbar>
						<IconButton
							onClick={() => onPush(ROUTE_PROFILE)}
							style={{marginRight: 5}}
							// popup={{content: 'Dein Profil', position: 'left center'}}
							tooltip={'Dein Profil'}
						>
							<Image src={avatar} avatar={true} style={{backgroundColor: 'white'}}/>
						</IconButton>
						<LogoutController />
					</Subbar>
				</Subbar>
			</header>
		);
	}
}

const m2s = state => ({

});
const m2d = dispatch => ({
	onPush: (to) => dispatch(push(to))
});

export default connect(m2s, m2d)(translate()(Header));


// WEBPACK FOOTER //
// ./src/containers/HeaderController.js